import React, { useState } from "react";
import { Spinner, Badge, Button } from "react-bootstrap";
import { useEticketingTicketsQuery } from "../../../../api/e-ticketing/e-ticketing.hooks";
import Pagination from "../../Pagination/Pagination";

const TicketsView = ({ booking, onBack }) => {
  const { data: ticketsData, isLoading } = useEticketingTicketsQuery({ bookingId: booking.booking_id });
  const tickets = ticketsData || [];

  const [currentPage, setCurrentPage] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const itemsPerPage = 10;

  const formatDate = (dateString) => {
    if (!dateString) return "--";
    return new Date(dateString).toLocaleDateString();
  };

  const filteredTickets = tickets.filter((ticket) => {
    const lowerSearch = searchTerm.toLowerCase();
    return (
      ticket.id?.toString().includes(lowerSearch) ||
      ticket.type?.toLowerCase().includes(lowerSearch) ||
      ticket.status?.toLowerCase().includes(lowerSearch)
    );
  });

  const totalPages = Math.ceil(filteredTickets.length / itemsPerPage);
  const paginatedTickets = filteredTickets.slice(
    currentPage * itemsPerPage,
    (currentPage + 1) * itemsPerPage
  );

  return (
    <div className="col-12">
      <div className="card">
        {/* Header */}
        <div className="card-header">
          <div className="d-flex align-items-center justify-content-between mb-3">
            <div className="d-flex align-items-center">
              <Button variant="link" className="p-0 me-3" onClick={onBack}>
                ← Back
              </Button>
              <h4 className="m-0">Tickets - Booking #{booking.booking_id}</h4>
            </div>
          </div>
          <div className="row">
            <div className="col-md-3">
              <small className="text-muted">Customer Name</small>
              <p className="mb-0 fw-bold">{booking.customerName || "--"}</p>
            </div>
            <div className="col-md-3">
              <small className="text-muted">Service</small>
              <p className="mb-0 fw-bold">{booking.service_name || "--"}</p>
            </div>
            <div className="col-md-3">
              <small className="text-muted">Route</small>
              <p className="mb-0 fw-bold">{booking.route_name || "--"}</p>
            </div>
            <div className="col-md-3">
              <small className="text-muted">Total Amount</small>
              <p className="mb-0 fw-bold">Rs. {booking.total_amount?.toLocaleString() || 0}</p>
            </div>
          </div>
        </div>

        {/* Tickets Table */}
        <div className="card-body">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h5 className="mb-0">Tickets ({tickets.length})</h5>
            <input
              type="text"
              className="form-control w-auto"
              placeholder="Search tickets..."
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value);
                setCurrentPage(0);
              }}
            />
          </div>

          {isLoading ? (
            <div className="d-flex justify-content-center align-items-center p-4">
              <Spinner animation="border" role="status" />
            </div>
          ) : (
            <>
              <div className="table-responsive">
                <table className="table table-striped">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Ticket ID</th>
                      <th>Type</th>
                      <th>Price</th>
                      <th>Date</th>
                      <th>Status</th>
                      <th>Created By</th>
                    </tr>
                  </thead>
                  <tbody>
                    {paginatedTickets.length > 0 ? (
                      paginatedTickets.map((ticket, i) => (
                        <tr key={ticket.id || i}>
                          <td>{currentPage * itemsPerPage + i + 1}</td>
                          <td>{ticket.id || "--"}</td>
                          <td>{ticket.type || "--"}</td>
                          <td>Rs. {ticket.price?.toLocaleString() || 0}</td>
                          <td>{formatDate(ticket.date)}</td>
                          <td>
                            <Badge bg={
                              ticket.status === "confirmed" ? "success" : 
                              ticket.status === "cancelled" ? "danger" : 
                              "secondary"
                            }>
                              {ticket.status || "N/A"}
                            </Badge>
                          </td>
                          <td>{ticket.created_by || "--"}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="8" className="text-center">
                          No tickets found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              {filteredTickets.length > 0 && (
                <Pagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  itemsPerPage={itemsPerPage}
                  totalItems={filteredTickets.length}
                  onPageChange={setCurrentPage}
                />
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default TicketsView;
